import React, { useEffect, useState } from "react"
import { useParams, useNavigate, Link } from "react-router-dom"
import { useSelector } from "react-redux"
import { selectUser } from "store/features/auth/authSlice"
import { toast } from "sonner"
import Breadcrumb from "components/Common/Breadcrumb"
import DashboardLoader from "components/Loader/DashboardLoader"
import logoImg from "../../assets/images/logo-sm.png"
import { useGetInvoiceByIdQuery } from "store/features/invoice/invoiceApi"

const ViewInvoice = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const user = useSelector(selectUser)

  const { data: invoice, isLoading } = useGetInvoiceByIdQuery(id)
  const [isSending, setIsSending] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const [currency, setCurrency] = useState("BDT")

  // Format currency
  const formatCurrency = amount => {
    return `BDT ${Math.round(amount).toLocaleString()}`
  }

  // Format date
  const formatDate = dateString => {
    if (!dateString) return ""
    const date = new Date(dateString)
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  // Format currency with code from saved data
  // const formatCurrencyWithCode = (amount, currencyCode = null) => {
  //   const useCurrency = currencyCode || currency
  //   const formattedAmount = Math.round(amount).toLocaleString()

  //   switch (useCurrency) {
  //     case "USD":
  //       return `USD ${formattedAmount}`
  //     case "CAD":
  //       return `CAD ${formattedAmount}`
  //     case "EURO":
  //       return `EURO ${formattedAmount}`
  //     case "BDT":
  //       return `BDT ${formattedAmount}`
  //     default:
  //       return `BDT ${formattedAmount}`
  //   }
  // }

  const formatCurrencyWithCode = (amount, currencyCode = null) => {
    const useCurrency = currencyCode || currency
    const numAmount = parseFloat(amount) || 0
    const formattedAmount = numAmount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })

    switch (useCurrency) {
      case "USD":
        return `USD ${formattedAmount}`
      case "CAD":
        return `CAD ${formattedAmount}`
      case "EURO":
        return `EURO ${formattedAmount}`
      default:
        return `BDT ${formattedAmount}`
    }
  }

  // Load currency and payment_to_collect from saved invoice
  useEffect(() => {
    if (invoice?.calculations) {
      if (invoice.calculations.currency) {
        setCurrency(invoice.calculations.currency)
      }
    }
  }, [invoice])

  // Generate email HTML from saved invoice data
  //   const generateEmailHTML = () => {
  //     const invoiceData = invoice?.invoice_data || {}
  //     const projectItems = invoice?.project_items || []
  //     const calculations = invoice?.calculations || {}

  //     const itemsRows = projectItems
  //       .map(
  //         item => `
  //       <tr>
  //         <td style="padding:12px;border-bottom:1px solid #eee;">${
  //           item.projectName || "-"
  //         }</td>
  //         <td style="padding:12px;border-bottom:1px solid #eee;">${
  //           item.description || "-"
  //         }</td>
  //         <td style="padding:12px;border-bottom:1px solid #eee;text-align:right;">${formatCurrency(
  //           item.amount
  //         )}</td>
  //       </tr>
  //     `
  //       )
  //       .join("")

  //     return `
  // <!DOCTYPE html>
  // <html>
  // <head>
  // <meta charset="UTF-8">
  // <title>Invoice</title>

  // <style>
  // @media only screen and (max-width:600px) {
  //   .stack-column {
  //     display: block !important;
  //     width: 100% !important;
  //     padding: 0 !important;
  //   }
  //   .stack-center {
  //     display: block !important;
  //     width: 100% !important;
  //     text-align: center !important;
  //     padding: 0 !important;
  //     margin-bottom: 10px;
  //   }
  //   .stack-left {
  //     display: block !important;
  //     width: 100% !important;
  //     text-align: left !important;
  //     padding-top: 10px !important;
  //   }
  // }
  // </style>
  // </head>

  // <body style="margin:0;padding:0;background:#eef2f7;font-family:Arial, sans-serif;">

  // <table width="100%" cellpadding="0" cellspacing="0" style="padding:16px;">
  // <tr>
  // <td align="center">

  // <table width="100%" cellpadding="0" cellspacing="0" style="max-width:900px;background:#fff;border-radius:16px;overflow:hidden;">

  // <!-- HEADER -->
  // <tr>
  // <td style="background:linear-gradient(135deg,#1e3a8a,#2563eb);color:white;padding:20px;">
  //   <table width="100%" cellpadding="0" cellspacing="0">
  //     <tr>
  //       <td class="stack-center" width="80" valign="middle" align="center">
  //         <img
  //           src="https://res.cloudinary.com/dlaeldpqy/image/upload/v1777306544/logo-sm_ubs6bx.png"
  //           width="60"
  //           style="display:block; margin:0 auto;">
  //       </td>
  //       <td class="stack-center" valign="middle" style="padding-left:10px;">
  //         <h1 style="margin:0;font-size:24px;">INVOICE</h1>
  //         <p style="margin:3px 0;font-size:12px;">Softzen IT Services</p>
  //       </td>
  //       <td class="stack-left" align="right" valign="middle" style="font-size:12px;">
  //         <p><strong>Invoice No:</strong> ${invoice?.invoice_no || ""}</p>
  //         <p><strong>Date:</strong> ${formatDate(
  //           invoiceData?.invoiceDetails?.invoiceDate
  //         )}</p>
  //         <p><strong>Due Date:</strong> ${formatDate(
  //           invoiceData?.invoiceDetails?.dueDate
  //         )}</p>
  //       </td>
  //     </tr>
  //   </table>
  // </td>
  // </tr>

  // <!-- CONTENT -->
  // <tr>
  // <td style="padding:20px;">

  // <!-- INFO GRID -->
  // <table width="100%" cellpadding="0" cellspacing="0">
  //   <tr>
  //     <td class="stack-column" width="50%" valign="top" style="padding-right:10px; margin-bottom:8px">
  //       <table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
  //         <tr>
  //           <td style="padding:16px;">
  //             <h3 style="margin:0 0 10px;color:#1e3a8a;">Bill To</h3>
  //             <p><strong>${
  //               invoiceData?.clientInfo?.companyName || "-"
  //             }</strong></p>
  //             <p>${invoiceData?.clientInfo?.address || "-"}</p>
  //             <p>${invoiceData?.clientInfo?.country || "-"}</p>
  //             <p>${invoiceData?.clientInfo?.phone || "-"}</p>
  //             <p>${invoiceData?.clientInfo?.email || "-"}</p>
  //           </td>
  //         </tr>
  //       </table>
  //     </td>
  //     <td class="stack-column" width="50%" valign="top" style="padding-left:10px;">
  //       <table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
  //         <tr>
  //           <td style="padding:16px;">
  //             <h3 style="margin:0 0 10px;color:#1e3a8a;">Softzen IT Services</h3>
  //             <p><strong>Head Office:</strong> ${
  //               invoiceData?.companyInfo?.headOffice || ""
  //             }</p>
  //             <p><strong>Bangladesh Office:</strong> ${
  //               invoiceData?.companyInfo?.bangladeshOffice || ""
  //             }</p>
  //             <p><strong>Phone:</strong> ${
  //               invoiceData?.companyInfo?.phoneBD || ""
  //             }, ${invoiceData?.companyInfo?.phoneCanada || ""}</p>
  //             <p><strong>Support:</strong> ${
  //               invoiceData?.companyInfo?.supportEmail || ""
  //             }</p>
  //             <p><strong>Billing:</strong> ${
  //               invoiceData?.companyInfo?.billingEmail || ""
  //             }</p>

  //           </td>
  //         </tr>
  //       </table>
  //     </td>
  //   </tr>
  // </table>

  // <!-- TABLE -->
  // <table width="100%" cellpadding="0" cellspacing="0" style="margin-top:20px;border-collapse:collapse;">
  // <tr style="background:#1e3a8a;color:white;">
  // <th style="padding:10px;text-align:left;">Project</th>
  // <th style="padding:10px;text-align:left;">Description</th>
  // <th style="padding:10px;text-align:right;">Amount</th>
  // </tr>
  // ${itemsRows}
  // <tr style="background:#f9fafb;font-weight:bold;">
  // <td colspan="2" style="padding:10px;">Total</td>
  // <td style="padding:10px;text-align:right;">${formatCurrency(
  //       calculations?.total
  //     )}</td>
  // </tr>
  // </table>

  // <!-- SUMMARY -->
  // <table width="100%" style="margin-top:20px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
  // <tr>
  // <td style="padding:10px;">Total</td>
  // <td align="right" style="padding:10px;">${formatCurrency(
  //       calculations?.total
  //     )}</td>
  // </tr>
  // <tr>
  // <td style="padding:10px;">Received</td>
  // <td align="right" style="padding:10px;color:green;">${formatCurrency(
  //       calculations?.received
  //     )}</td>
  // </tr>
  // <tr>
  // <td style="padding:10px;">Outstanding</td>
  // <td align="right" style="padding:10px;color:red;">${formatCurrency(
  //       calculations?.outstanding
  //     )}</td>
  // </tr>
  // </table>

  // <!-- PAYMENT -->
  // <table width="100%" style="margin-top:20px;background:#fff7ed;border-left:4px solid #f97316;text-align:center;">
  // <tr>
  // <td style="padding:16px;">
  // <p>Please complete the pending payment</p>
  // <h2 style="color:red;">${formatCurrency(calculations?.outstanding)}</h2>
  // <p>Kindly settle this payment by: ${formatDate(
  //       invoiceData?.invoiceDetails?.dueDate
  //     )}</p>
  // </td>
  // </tr>
  // </table>

  // <!-- METHODS -->
  // <h3 style="margin-top:20px;color:#1e3a8a;">Payment Methods</h3>

  // <table width="100%" style="margin-top:10px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:12px;">
  // <tr><td style="padding:12px;">
  // <p><strong>🏦 Bank Transfer</strong></p>
  // <p>${invoiceData?.paymentMethods?.bankName || ""}</p>
  // <p>Account: ${invoiceData?.paymentMethods?.bankAccount || ""}</p>
  // <p>Routing: ${invoiceData?.paymentMethods?.bankRouting || ""}</p>
  // <p>SWIFT: ${invoiceData?.paymentMethods?.bankSwift || ""}</p>
  // </td></tr>
  // </table>

  // <table width="100%" style="margin-top:10px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:12px;">
  // <tr><td style="padding:12px;">
  // <p><strong>📱 bKash</strong></p>
  // <p>${invoiceData?.paymentMethods?.bkashNumber || ""}</p>
  // <p>Send transaction ID after payment</p>
  // </td></tr>
  // </table>

  // <table width="100%" style="margin-top:10px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:12px;">
  // <tr><td style="padding:12px;">
  // <p><strong>💳 Stripe</strong></p>
  // <p>${invoiceData?.paymentMethods?.stripeLink || ""}</p>
  // </td></tr>
  // </table>

  // <div style="margin-top:20px;text-align:center;font-size:13px;">
  // <p>Best regards,</p>
  // <p><strong>Softzen IT Services</strong></p>
  // <p>${invoiceData?.companyInfo?.phoneCanada || ""}</p>
  // <p>${invoiceData?.companyInfo?.website || ""}</p>
  // </div>

  // </td>
  // </tr>

  // <!-- FOOTER -->
  // <tr>
  // <td style="text-align:center;padding:20px;background:#f3f4f6;font-size:12px;">
  // ${
  //   invoiceData?.footerText || "Thank you for your business with Softzen IT Services"
  // }
  // </td>
  // </tr>

  // </table>

  // </td>
  // </tr>
  // </table>

  // </body>
  // </html>
  // `
  //   }

  // Generate email HTML from saved invoice data
  const generateEmailHTML = () => {
    const invoiceData = invoice?.invoice_data || {}
    const projectItems = invoice?.project_items || []
    const calculations = invoice?.calculations || {}
    const savedCurrency = calculations?.currency || "BDT"
    const paymentToCollect =
      calculations?.payment_to_collect || calculations?.outstanding || 0

    // const getFormatCurrency = amount => {
    //   const formattedAmount = Math.round(amount).toLocaleString()
    //   switch (savedCurrency) {
    //     case "USD":
    //       return `USD ${formattedAmount}`
    //     case "CAD":
    //       return `CAD ${formattedAmount}`
    //     case "EURO":
    //       return `EURO ${formattedAmount}`
    //     default:
    //       return `BDT ${formattedAmount}`
    //   }
    // }

    const getFormatCurrency = amount => {
      const numAmount = parseFloat(amount) || 0
      const formattedAmount = numAmount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      switch (savedCurrency) {
        case "USD":
          return `USD ${formattedAmount}`
        case "CAD":
          return `CAD ${formattedAmount}`
        case "EURO":
          return `EURO ${formattedAmount}`
        default:
          return `BDT ${formattedAmount}`
      }
    }

    const itemsRows = projectItems
      .map(
        item => `
    <tr>
      <td style="padding:12px;border-bottom:1px solid #eee;">${item.projectName || "-"
          }</td>
      <td style="padding:12px;border-bottom:1px solid #eee;">${item.description || "-"
          }</td>
      <td style="padding:12px;border-bottom:1px solid #eee;text-align:right;">${getFormatCurrency(
            item.amount
          )}</td>
    </tr>
    `
      )
      .join("")

    return `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>Invoice</title>

<style>
@media only screen and (max-width:600px) {
  .stack-column {
    display: block !important;
    width: 100% !important;
    padding: 0 !important;
  }
  .stack-center {
    display: block !important;
    width: 100% !important;
    text-align: center !important;
    padding: 0 !important;
    margin-bottom: 10px;
  }
  .stack-left {
    display: block !important;
    width: 100% !important;
    text-align: left !important;
    padding-top: 10px !important;
  }
}
</style>
</head>

<body style="margin:0;padding:0;background:#eef2f7;font-family:Arial, sans-serif;">

<table width="100%" cellpadding="0" cellspacing="0" style="padding:16px;">
<tr>
<td align="center">

<table width="100%" cellpadding="0" cellspacing="0" style="max-width:900px;background:#fff;border-radius:16px;overflow:hidden;">

<!-- HEADER -->
<tr>
<td style="background:linear-gradient(135deg,#1e3a8a,#2563eb);color:white;padding:20px;">
  <table width="100%" cellpadding="0" cellspacing="0">
    <tr>
      <td class="stack-center" width="80" valign="middle" align="center">
        <img 
          src="https://res.cloudinary.com/dlaeldpqy/image/upload/v1777306544/logo-sm_ubs6bx.png"
          width="60"
          style="display:block; margin:0 auto;">
      </td>
      <td class="stack-center" valign="middle" style="padding-left:10px;">
        <h1 style="margin:0;font-size:24px;">INVOICE</h1>
        <p style="margin:3px 0;font-size:12px;">Softzen IT Services</p>
      </td>
      <td class="stack-left" align="right" valign="middle" style="font-size:12px;">
        <p><strong>Invoice No:</strong> ${invoice?.invoice_no || ""}</p>
        <p><strong>Date:</strong> ${formatDate(
      invoiceData?.invoiceDetails?.invoiceDate
    )}</p>
       
      </td>
    </tr>
  </table>
</td>
</tr>

<!-- CONTENT -->
<tr>
<td style="padding:20px;">

<!-- INFO GRID -->
<table width="100%" cellpadding="0" cellspacing="0">
  <tr>
    <td class="stack-column" width="50%" valign="top" style="padding-right:10px; margin-bottom:8px">
      <table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
        <tr>
          <td style="padding:16px;">
            <h3 style="margin:0 0 10px;color:#1e3a8a;">Bill To</h3>
            <p><strong>${invoiceData?.clientInfo?.companyName || "-"
      }</strong></p>
            <p>${invoiceData?.clientInfo?.address || "-"}</p>
            <p>${invoiceData?.clientInfo?.country || "-"}</p>
            <p>${invoiceData?.clientInfo?.phone || "-"}</p>
            <p>${invoiceData?.clientInfo?.email || "-"}</p>
          </td>
        </tr>
      </table>
    </td>
    <td class="stack-column" width="50%" valign="top" style="padding-left:10px;">
      <table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
        <tr>
          <td style="padding:16px;">
            <h3 style="margin:0 0 10px;color:#1e3a8a;">Softzen IT Services</h3>
            <p><strong>Head Office:</strong> ${invoiceData?.companyInfo?.headOffice || ""
      }</p>
            <p><strong>Bangladesh Office:</strong> ${invoiceData?.companyInfo?.bangladeshOffice || ""
      }</p>
            <p><strong>Phone:</strong> ${invoiceData?.companyInfo?.phoneBD || ""
      }, ${invoiceData?.companyInfo?.phoneCanada || ""}</p>
            <p><strong>Support:</strong> ${invoiceData?.companyInfo?.supportEmail || ""
      }</p>
            <p><strong>Billing:</strong> ${invoiceData?.companyInfo?.billingEmail || ""
      }</p>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>

<!-- TABLE -->
<table width="100%" cellpadding="0" cellspacing="0" style="margin-top:20px;border-collapse:collapse;">
<tr style="background:#1e3a8a;color:white;">
<th style="padding:10px;text-align:left;">Project</th>
<th style="padding:10px;text-align:left;">Description</th>
<th style="padding:10px;text-align:right;">Amount</th>
</tr>
${itemsRows}
<tr style="background:#f9fafb;font-weight:bold;">
<td colspan="2" style="padding:10px;">Total</td>
<td style="padding:10px;text-align:right;">${getFormatCurrency(
        calculations?.total
      )}</td>
</tr>
</table>

<!-- SUMMARY -->
<table width="100%" style="margin-top:20px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
<tr>
<td style="padding:10px;">Total</td>
<td align="right" style="padding:10px;">${getFormatCurrency(
        calculations?.total
      )}</td>
</tr>
<tr>
<td style="padding:10px;">Received</td>
<td align="right" style="padding:10px;color:green;">${getFormatCurrency(
        calculations?.received
      )}</td>
</tr>
<tr>
<td style="padding:10px;">Outstanding</td>
<td align="right" style="padding:10px;color:red;">${getFormatCurrency(
        calculations?.outstanding
      )}</td>
</tr>
</table>

<!-- PAYMENT -->
<table width="100%" style="margin-top:20px;background:#fff7ed;border-left:4px solid #f97316;text-align:center;">
<tr>
<td style="padding:16px;">
<p>Minimum Due by: ${formatDate(invoiceData.dueDate)}</p>
<h2 style="color:red;">${formatCurrencyWithCode(paymentToCollect)}</h2>
</td>
</tr>
</table>

<!-- METHODS -->
<h3 style="margin-top:20px;color:#1e3a8a;">Payment Methods</h3>

<table width="100%" style="margin-top:10px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:12px;">
<tr><td style="padding:12px;">
<p><strong>🏦 Bank Transfer</strong></p>
<p>${invoiceData?.paymentMethods?.bankName || ""}</p>
<p>Account: ${invoiceData?.paymentMethods?.bankAccount || ""}</p>
<p>Routing: ${invoiceData?.paymentMethods?.bankRouting || ""}</p>
<p>SWIFT: ${invoiceData?.paymentMethods?.bankSwift || ""}</p>
</td></tr>
</table>

<table width="100%" style="margin-top:10px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:12px;">
<tr><td style="padding:12px;">
<p><strong>📱 bKash</strong></p>
<p>${invoiceData?.paymentMethods?.bkashNumber || ""}</p>
<p>Send transaction ID after payment</p>
</td></tr>
</table>

<table width="100%" style="margin-top:10px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:12px;">
<tr><td style="padding:12px;">
<p><strong>💳 Stripe</strong></p>
<p>${invoiceData?.paymentMethods?.stripeLink || ""}</p>
</td></tr>
</table>

${invoiceData?.paymentMethods?.interacEmail &&
        invoiceData.paymentMethods.interacEmail.trim() !== ""
        ? `
<table width="100%" style="margin-top:10px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:12px;">
<td style="padding:12px;">
<p><strong>🏦 Interac e-Transfer</strong></p>
<p>Send payment to: <strong>${invoiceData.paymentMethods.interacEmail}</strong></p>
</td>
</table>
`
        : ""
      }

<div style="margin-top:20px;text-align:center;font-size:13px;">
<p>Best regards,</p>
<p><strong>Softzen IT Services</strong></p>
<p>${invoiceData?.companyInfo?.phoneCanada || ""}</p>
<p>${invoiceData?.companyInfo?.website || ""}</p>
</div>

</td>
</tr>

<!-- FOOTER -->
<tr>
<td style="text-align:center;padding:20px;background:#f3f4f6;font-size:12px;">
${invoiceData?.footerText || "Thank you for your business with Softzen IT Services"
      }
</td>
</tr>

</table>

</td>
</tr>
</table>

</body>
</html>
`
  }

  // Function to send email only
  const sendEmailOnly = async recipientEmail => {
    const emailHTML = generateEmailHTML()

    const response = await fetch(
      "https://resend-server.qwikit.ca/api/send-invoice",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: recipientEmail,
          subject: `Invoice #${invoice?.invoice_no} - Softzen IT Services`,
          html: emailHTML,
          invoiceNo: invoice?.invoice_no,
          clientName: invoice?.invoice_data?.clientInfo?.companyName,
        }),
      }
    )

    return response.json()
  }

  // Handle Send Only
  const handleSendOnly = async () => {
    const recipientEmail = invoice?.sent_to

    if (!recipientEmail) {
      toast.error("Client email is required to send invoice")
      return
    }

    try {
      setIsSending(true)

      const emailData = await sendEmailOnly(recipientEmail)

      if (emailData.success) {
        toast.success(
          `Invoice #${invoice?.invoice_no} resent successfully to ${recipientEmail}`
        )
        setShowModal(false)
      } else {
        throw new Error(emailData.error || "Failed to send invoice")
      }
    } catch (error) {
      console.error("Error sending invoice:", error)
      toast.error("Failed to send invoice. Please try again.")
    } finally {
      setIsSending(false)
    }
  }

  // Open modal before sending
  const openSendModal = () => {
    setShowModal(true)
  }

  if (isLoading) {
    return <DashboardLoader />
  }

  if (!invoice) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="alert alert-danger">Invoice not found</div>
          <Link to="/all-invoices" className="btn btn-primary">
            Back to Invoices
          </Link>
        </div>
      </div>
    )
  }

  const invoiceData = invoice?.invoice_data || {}
  const calculations = invoice?.calculations || {}

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb
          title="Invoice"
          breadcrumbItem={`Invoice #${invoice?.invoice_no}`}
        />

        {/* Action Buttons */}
        <div className="row mb-4 no-print">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <Link to="/all-invoices" className="btn btn-secondary">
                <i className="fas fa-arrow-left me-1"></i> Back to Invoices
              </Link>
              <button
                type="button"
                className="btn btn-success"
                onClick={openSendModal}
                disabled={isSending}
              >
                <i className="fas fa-envelope me-1"></i>
                {isSending ? "Sending..." : "Resend Invoice to Client"}
              </button>
            </div>
          </div>
        </div>

        {/* Invoice Preview */}
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title mb-3 text-center">Invoice Preview</h5>
                <div
                  className="invoice"
                  style={{
                    maxWidth: "1000px",
                    margin: "0 auto",
                    background: "#fff",
                    borderRadius: "16px",
                    overflow: "hidden",
                    boxShadow: "0 20px 50px rgba(0,0,0,0.08)",
                  }}
                >
                  <div
                    style={{
                      background: "linear-gradient(135deg, #1e3a8a, #2563eb)",
                      color: "white",
                      padding: "20px",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: "16px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "10px",
                          background: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "8px",
                          border: "1px dashed rgba(255,255,255,0.6)",
                        }}
                      >
                        <img
                          src={logoImg}
                          alt="Qwik IT"
                          style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <div>
                        <h1
                          style={{
                            margin: 0,
                            fontSize: "24px",
                            letterSpacing: "1px",
                          }}
                        >
                          INVOICE
                        </h1>
                        <p
                          style={{
                            margin: "3px 0",
                            fontSize: "12px",
                            opacity: 0.9,
                          }}
                        >
                          Softzen IT Services
                        </p>
                      </div>
                    </div>
                    <div style={{ textAlign: "left" }}>
                      <p style={{ margin: "4px 0", fontSize: "12px" }}>
                        <strong>Invoice No:</strong> {invoice?.invoice_no}
                      </p>
                      <p style={{ margin: "4px 0", fontSize: "12px" }}>
                        <strong>Date:</strong>{" "}
                        {formatDate(invoiceData?.invoiceDetails?.invoiceDate)}
                      </p>
                    </div>
                  </div>

                  <div style={{ padding: "20px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          background: "#f9fafb",
                          border: "1px solid #e5e7eb",
                          padding: "16px",
                          borderRadius: "12px",
                          wordBreak: "break-word",
                        }}
                      >
                        <h3
                          style={{
                            marginTop: 0,
                            marginBottom: "12px",
                            color: "#1e3a8a",
                            fontSize: "16px",
                          }}
                        >
                          Bill To
                        </h3>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>
                            {invoiceData?.clientInfo?.companyName || "-"}
                          </strong>
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          {invoiceData?.clientInfo?.address || "-"}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          {invoiceData?.clientInfo?.country || "-"}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          {invoiceData?.clientInfo?.phone || "-"}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          {invoiceData?.clientInfo?.email || "-"}
                        </p>
                      </div>
                      <div
                        style={{
                          flex: 1,
                          background: "#f9fafb",
                          border: "1px solid #e5e7eb",
                          padding: "16px",
                          borderRadius: "12px",
                          wordBreak: "break-word",
                        }}
                      >
                        <h3
                          style={{
                            marginTop: 0,
                            marginBottom: "12px",
                            color: "#1e3a8a",
                            fontSize: "16px",
                          }}
                        >
                          Softzen IT Services
                        </h3>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>Head Office:</strong>{" "}
                          {invoiceData?.companyInfo?.headOffice || ""}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>Bangladesh Office:</strong>{" "}
                          {invoiceData?.companyInfo?.bangladeshOffice || ""}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>Phone:</strong>{" "}
                          {invoiceData?.companyInfo?.phoneBD || ""},{" "}
                          {invoiceData?.companyInfo?.phoneCanada || ""}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>Support:</strong>{" "}
                          {invoiceData?.companyInfo?.supportEmail || ""}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>Billing:</strong>{" "}
                          {invoiceData?.companyInfo?.billingEmail || ""}
                        </p>

                        {/* <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>Web:</strong>{" "}
                          {invoiceData?.companyInfo?.website || ""}
                        </p> */}
                      </div>
                    </div>

                    <div
                      style={{
                        overflowX: "auto",
                        margin: "16px 0",
                        WebkitOverflowScrolling: "touch",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          minWidth: "500px",
                        }}
                      >
                        <thead>
                          <tr style={{ background: "#1e3a8a", color: "white" }}>
                            <th
                              style={{
                                padding: "10px 12px",
                                textAlign: "left",
                                fontSize: "13px",
                              }}
                            >
                              Project
                            </th>
                            <th
                              style={{
                                padding: "10px 12px",
                                textAlign: "left",
                                fontSize: "13px",
                              }}
                            >
                              Description
                            </th>
                            <th
                              style={{
                                padding: "10px 12px",
                                textAlign: "right",
                                fontSize: "13px",
                              }}
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {(invoice?.project_items || []).map((item, idx) => (
                            <tr key={idx}>
                              <td
                                style={{
                                  padding: "10px 12px",
                                  borderBottom: "1px solid #eee",
                                  fontSize: "13px",
                                  wordBreak: "break-word",
                                }}
                              >
                                {item.projectName || "-"}
                              </td>
                              <td
                                style={{
                                  padding: "10px 12px",
                                  borderBottom: "1px solid #eee",
                                  fontSize: "13px",
                                  wordBreak: "break-word",
                                }}
                              >
                                {item.description || "-"}
                              </td>
                              <td
                                style={{
                                  padding: "10px 12px",
                                  borderBottom: "1px solid #eee",
                                  textAlign: "right",
                                  fontSize: "13px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {formatCurrencyWithCode(
                                  item.amount,
                                  calculations?.currency
                                )}
                              </td>
                            </tr>
                          ))}
                          <tr
                            style={{
                              fontWeight: "bold",
                              background: "#f9fafb",
                            }}
                          >
                            <td
                              colSpan="2"
                              style={{ padding: "10px 12px", fontSize: "13px" }}
                            >
                              <strong>Total</strong>
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                textAlign: "right",
                                fontSize: "13px",
                              }}
                            >
                              <strong>
                                {formatCurrencyWithCode(
                                  calculations?.total,
                                  calculations?.currency
                                )}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div
                      style={{
                        marginTop: "20px",
                        background: "#f9fafb",
                        padding: "16px",
                        borderRadius: "12px",
                        border: "1px solid #e5e7eb",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "8px 0",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        <span>Total</span>
                        <span>
                          {formatCurrencyWithCode(
                            calculations?.total,
                            calculations?.currency
                          )}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "8px 0",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        <span>Received</span>
                        <span style={{ color: "#16a34a", fontWeight: "bold" }}>
                          {formatCurrencyWithCode(
                            calculations?.received,
                            calculations?.currency
                          )}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "8px 0",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        <span>Outstanding</span>
                        <span style={{ color: "#dc2626", fontWeight: "bold" }}>
                          {formatCurrencyWithCode(
                            calculations?.outstanding,
                            calculations?.currency
                          )}
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        marginTop: "24px",
                        padding: "16px",
                        borderRadius: "12px",
                        background: "#fff7ed",
                        borderLeft: "4px solid #f97316",
                        textAlign: "center",
                      }}
                    >
                      <p>Minimum Due by:{" "}{formatDate(invoiceData?.invoiceDetails?.dueDate)}</p>
                      <h2
                        style={{
                          margin: "10px 0",
                          color: "#dc2626",
                          fontSize: "24px",
                        }}
                      >
                        {/* {formatCurrencyWithCode(
                          calculations?.payment_to_collect,
                          calculations?.currency
                        )} */}

                        {formatCurrencyWithCode(
                          calculations?.payment_to_collect ||
                          calculations?.outstanding ||
                          0,
                          calculations?.currency
                        )}
                      </h2>
                    </div>

                    <h3
                      style={{
                        marginTop: "24px",
                        color: "#1e3a8a",
                        fontSize: "16px",
                      }}
                    >
                      Payment Methods
                    </h3>

                    <div
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #e5e7eb",
                        padding: "14px",
                        borderRadius: "12px",
                        marginTop: "12px",
                        wordBreak: "break-word",
                      }}
                    >
                      <h4
                        style={{
                          margin: "0 0 8px",
                          color: "#1e3a8a",
                          fontSize: "15px",
                        }}
                      >
                        🏦 Bank Transfer
                      </h4>
                      <p style={{ margin: "4px 0", fontSize: "13px" }}>
                        {invoiceData?.paymentMethods?.bankName || ""}
                      </p>
                      <p style={{ margin: "4px 0", fontSize: "13px" }}>
                        Account:{" "}
                        {invoiceData?.paymentMethods?.bankAccount || ""}
                      </p>
                      <p style={{ margin: "4px 0", fontSize: "13px" }}>
                        Routing:{" "}
                        {invoiceData?.paymentMethods?.bankRouting || ""}
                      </p>
                      <p style={{ margin: "4px 0", fontSize: "13px" }}>
                        SWIFT: {invoiceData?.paymentMethods?.bankSwift || ""}
                      </p>
                    </div>

                    <div
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #e5e7eb",
                        padding: "14px",
                        borderRadius: "12px",
                        marginTop: "12px",
                        wordBreak: "break-word",
                      }}
                    >
                      <h4
                        style={{
                          margin: "0 0 8px",
                          color: "#1e3a8a",
                          fontSize: "15px",
                        }}
                      >
                        📱 bKash
                      </h4>
                      <p style={{ margin: "4px 0", fontSize: "13px" }}>
                        {invoiceData?.paymentMethods?.bkashNumber || ""}
                      </p>
                      <p style={{ margin: "4px 0", fontSize: "13px" }}>
                        Send transaction ID after payment
                      </p>
                    </div>

                    <div
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #e5e7eb",
                        padding: "14px",
                        borderRadius: "12px",
                        marginTop: "12px",
                        wordBreak: "break-word",
                      }}
                    >
                      <h4
                        style={{
                          margin: "0 0 8px",
                          color: "#1e3a8a",
                          fontSize: "15px",
                        }}
                      >
                        💳 Stripe
                      </h4>
                      <p style={{ margin: "4px 0", fontSize: "13px" }}>
                        {invoiceData?.paymentMethods?.stripeLink || ""}
                      </p>
                    </div>

                    {invoiceData?.paymentMethods?.interacEmail &&
                      invoiceData.paymentMethods.interacEmail.trim() !== "" && (
                        <div
                          style={{
                            background: "#f8fafc",
                            border: "1px solid #e5e7eb",
                            padding: "14px",
                            borderRadius: "12px",
                            marginTop: "12px",
                            wordBreak: "break-word",
                          }}
                        >
                          <h4
                            style={{
                              margin: "0 0 8px",
                              color: "#1e3a8a",
                              fontSize: "15px",
                            }}
                          >
                            🏦 Interac e-Transfer
                          </h4>
                          <p style={{ margin: "4px 0", fontSize: "13px" }}>
                            Send payment to:{" "}
                            <strong>
                              {invoiceData.paymentMethods.interacEmail}
                            </strong>
                          </p>
                        </div>
                      )}

                    <div
                      style={{
                        marginTop: "24px",
                        paddingTop: "16px",
                        borderTop: "1px solid #e5e7eb",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      <p style={{ margin: "4px 0" }}>Best regards,</p>
                      <p style={{ margin: "4px 0" }}>
                        <strong>Softzen IT Services</strong>
                      </p>
                      <p style={{ margin: "4px 0" }}>
                        {invoiceData?.companyInfo?.phoneCanada || ""}
                      </p>
                      <p style={{ margin: "4px 0" }}>
                        {invoiceData?.companyInfo?.website || ""}
                      </p>
                    </div>
                  </div>

                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      background: "#f3f4f6",
                      fontSize: "12px",
                      color: "#555",
                    }}
                  >
                    {invoiceData?.footerText ||
                      "Thank you for your business with Softzen IT Services"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons Bottom */}
        <div className="row mt-4 mb-4 no-print">
          <div className="col-12">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-success"
                onClick={openSendModal}
                disabled={isSending}
              >
                <i className="fas fa-envelope me-1"></i>
                {isSending ? "Sending..." : "Resend Invoice to Client"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Send Options */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "400px",
              padding: "24px",
              position: "relative",
              boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
                color: "#666",
              }}
            >
              ✕
            </button>

            <h3
              style={{ marginTop: 0, marginBottom: "20px", color: "#1e3a8a" }}
            >
              Resend Invoice
            </h3>

            <p style={{ marginBottom: "24px", color: "#555" }}>
              Send this invoice to {invoice?.sent_to}?
            </p>

            <button
              onClick={handleSendOnly}
              disabled={isSending}
              style={{
                width: "100%",
                padding: "12px",
                marginBottom: "12px",
                backgroundColor: "#2563eb",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: isSending ? "not-allowed" : "pointer",
                opacity: isSending ? 0.6 : 1,
              }}
            >
              {isSending ? "Sending..." : "Send Invoice"}
            </button>

            <button
              onClick={() => setShowModal(false)}
              disabled={isSending}
              style={{
                width: "100%",
                padding: "12px",
                marginTop: "12px",
                backgroundColor: "#f3f4f6",
                color: "#374151",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "14px",
                cursor: isSending ? "not-allowed" : "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default ViewInvoice
